import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { isEqual, isEmpty } from 'lodash';
import CommonStudySelector from '../common/CommonStudySelector';
import CustomDragLayer from '../common/DynamicDnD/CustomDragLayer';
import runIcon from '../../images/run_report_icon_normal.png';
import runHoverIcon from '../../images/run_report_icon_hover.png';
import runDisabledIcon from '../../images/run_report_icon_disabled.png';
import { SCRATCH_TAB_SELECTED, FLEX_STUDY_TAG } from '../../constants';
import * as geographyActions from '../../actions/geographyActions';
import ProfileTabsV2 from './ProfileTabsV2';
import ExpressionCreatorV2 from './ExpressionCreatorV2';
import SampleTabsV2 from './SampleTabsV2';

class DictionarySearchV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPreviewItems: [],
      studies: props.studies ? props.studies : [],
      defaultStudy: {},
      showWeightType: true,
    };
    this.expressionCreator = React.createRef();
  }

  componentDidMount() {
    this.onMount();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.studies && nextProps.studies !== this.props.studies) {
      this.setState(() => ({ studies: nextProps.studies }));
    }

    if (
      nextProps.moduleStudy &&
      !isEmpty(nextProps.moduleStudy) &&
      !this.props.dataScreen &&
      !isEqual(nextProps.moduleStudy, this.props.moduleStudy)
    ) {
      this.setState(() => ({
        defaultStudy: nextProps.moduleStudy,
      }));
      if (
        nextProps.moduleStudy &&
        nextProps.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
      ) {
        this.props.geographyActions.handleSearchGeographyTreeLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          nextProps.moduleStudy.pn,
          { nodeId: 0, fname: null }
        );
        this.props.geographyActions.handleGeographySearch(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          nextProps.moduleStudy.pn
        );
      } else {
        this.props.geographyActions.clearGeographySmartSearchData();
      }
    }
  }

  onMount = () => {
    if (!this.props.dataScreen && this.props.moduleStudy) {
      this.setState(() => ({
        defaultStudy: this.props.moduleStudy,
      }));
    }
  };

  handleAnswersPreview = selectedAnswers =>
    this.setState({ selectedPreviewItems: [...selectedAnswers] });

  handleSelectedKeywords = (
    selectedKeywordNodes,
    titlePrefix,
    selectedOperator
  ) =>
    this.expressionCreator.current.handleSelectedKeywords(
      selectedKeywordNodes,
      titlePrefix,
      selectedOperator
    );

  moveAppendToCodingBox = (
    isMove,
    expressionKeyword,
    functiontitle,
    smartSearchArray
  ) => {
    this.expressionCreator.current.moveAppendToCodingBox(
      isMove,
      expressionKeyword,
      functiontitle,
      smartSearchArray
    );
  };

  handleCrosstabEditToDictionary = (idKey, dataSmartSearch, keyword) => {
    this.expressionCreator.current.handleCrosstabEditToDictionary(
      idKey,
      dataSmartSearch,
      keyword
    );
  };

  handleProbabilitiesEditClick = (rowData, colData) => {
    this.expressionCreator.current.handleProbabilitiesEditClick(
      rowData,
      colData
    );
  };

  tabTracker = index => {
    if (index === 1) {
      this.props.trackerFn({ action: SCRATCH_TAB_SELECTED });
    }
  };

  setSelectedStudy = (selectedStudy, updatedWeightType) => {
    this.setState(() => ({ actualWeightType: selectedStudy.wt }));
    this.props.handleStudyChange(selectedStudy, updatedWeightType);
  };

  getSampleWeightedOfExistingKPIs = weightList => {
    const {
      loginResponse,
      activeAccountId,
      moduleStudy,
      BasesDataGridData,
      ColumnsDataGridData,
      RowsDataGridData,
      ScratchDataGridData,
    } = this.props;
    let sampleWeightedParams = {
      token: loginResponse.data.token,
      uid: loginResponse.data.uid,
      accountId: activeAccountId,
      productNo: moduleStudy.pn,
      weightType: weightList.wt,
      divisor: weightList.dv || 1000,
      weightChange: true,
    };

    if (BasesDataGridData && BasesDataGridData.length > 0) {
      const userStateData = this.generateGridData(BasesDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BasesDataGrid',
        targetGrid: 'BasesDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
    }

    if (ColumnsDataGridData && ColumnsDataGridData.length > 0) {
      const userStateData = this.generateGridData(ColumnsDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
        isLabelUpdated: userStateData.isLabelUpdated,
      };
      this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
    }

    if (RowsDataGridData && RowsDataGridData.length > 0) {
      const userStateData = this.generateGridData(RowsDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'RowsDataGrid',
        targetGrid: 'RowsDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
        isLabelUpdated: userStateData.isLabelUpdated,
      };
      this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
    }

    if (ScratchDataGridData && ScratchDataGridData.length > 0) {
      const userStateData = this.generateGridData(ScratchDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ScratchDataGrid',
        targetGrid: 'ScratchDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
    }
  };

  generateGridData = gridData => {
    const data = {
      selectedKeywords: [],
      selectedNames: [],
      originalNames: [],
      recTypes: [],
      dataSmartSearch: [],
      isLabelUpdated: [],
    };
    gridData.forEach(item => {
      data.selectedKeywords.push(item.keyword);
      data.selectedNames.push(item.title);
      data.originalNames.push(item.originalTitle);
      data.recTypes.push(item.recType || item.rectype || item.type);
      data.dataSmartSearch.push(item.dataSmartSearch);
      data.isLabelUpdated.push(item.isLabelUpdated);
    });
    return data;
  };

  setStudyAsPreviousStudy = currentStudy => {
    this.commonStudySelectorRef.setStudyAsPreviousStudy(currentStudy);
  };

  render() {
    return (
      <div className="dictionary-search-editor" style={this.props.windowHeight}>
        <div className="appBreadcrumb">
          <div className="crosstab-study-selector">
            <CommonStudySelector
              data-test='commonStudy-selector'
              studies={this.state.studies}
              featureID={this.props.featureID}
              defaultStudy={this.state.defaultStudy}
              // dataOnScreen={this.props.dataOnScreen}
              alertMsg={this.props.alertMsg}
              setMethod={this.setSelectedStudy}
              showWeightType={this.state.showWeightType}
              handleChangeWeightType={this.props.handleChangeWeightType}
              hideWeightType={this.props.hideWeightType}
              menuName={this.props.menuName}
              selectedWeightType={this.props.weightTypes}
              getSampleWeightedOfExistingKPIs={
                this.getSampleWeightedOfExistingKPIs
              }
              runReport={this.props.runReport}
              commonStudySelectorRef={ref =>
                (this.commonStudySelectorRef = ref)
              }
            />
          </div>
          {this.props.dataScreen !== 'DataHaul' &&
            this.props.sampleTabsEnabled && (
              <div className="essential-breadcrumb">
                {this.props.backBtnLabel && this.props.backBtnAction && (
                  <div className="back-to-dictionary-search">
                    <Link onClick={this.props.backBtnAction}>
                      {this.props.backBtnLabel}
                    </Link>
                  </div>
                )}
                <span className="parent">{this.props.mainMenuName} / </span>
                {this.props.moduleName}
                {this.props.handleRun && (
                  <div className="run-button-container">
                    {!this.props.isRunEnabled ? (
                      <a
                        className="button square-button float-right dictionary-run-button"
                        disabled
                      >
                        <div className="square">
                          <img
                            src={runDisabledIcon}
                            data-src={runDisabledIcon}
                            data-hoversrc={runDisabledIcon}
                            alt="Run Crosstab Button"
                            title={
                              this.props.moduleStudy &&
                              this.props.moduleStudy.st
                                .toLowerCase()
                                .includes(FLEX_STUDY_TAG)
                                ? 'Select a geography as base to continue'
                                : 'Run'
                            }
                          />
                        </div>
                      </a>
                    ) : (
                      <a
                        className="button square-button float-right dictionary-run-button"
                        onMouseOver={this.mouseOver}
                        onMouseOut={this.mouseOut}
                        onClick={this.props.handleRun}
                      >
                        <div className="square">
                          <img
                            src={runIcon}
                            data-src={runIcon}
                            data-hoversrc={runHoverIcon}
                            alt="Run Crosstab Button"
                            title="Run"
                          />
                        </div>
                      </a>
                    )}
                  </div>
                )}
              </div>
            )}{' '}
        </div>

        <div className="expanded row">
          <div
            className="row expanded clearfix"
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '5px',
              margin: '0 15px 0 0',
            }}
          >
            <div className="small-12 medium-8 large-8 columns">
              {this.props.dictionaryTabsList &&
                this.props.dictionaryTabsList.length > 0 && (
                  <div className="column row expanded">
                    <CustomDragLayer
                      selectedPreviewItems={this.state.selectedPreviewItems}
                    />
                    <ProfileTabsV2
                      selectedModule={this.props.moduleName}
                      moduleStudy={this.props.moduleStudy}
                      handleAnswersPreview={this.handleAnswersPreview}
                      handleSelectedKeywords={this.handleSelectedKeywords}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      gridData={this.props.gridData}
                      trackerFn={this.props.trackerFn}
                      moduleWeigthType={this.props.weightTypes}
                      dictionaryTabsList={this.props.dictionaryTabsList || []}
                      noExpressionBox={
                        this.props.noExpressionBox
                          ? this.props.noExpressionBox
                          : false
                      }
                      rightGridList={this.props.rightGridList || []}
                      moduleColumns={this.props.ColumnsDataGridData}
                      moduleRows={this.props.RowsDataGridData}
                      moduleAction={this.props.moduleAction}
                      functionProbabilitiesFlag={
                        this.props.functionProbabilitiesFlag || false
                      }
                      breadcrumbFlag={this.props.breadcrumbFlag}
                      refreshFlag={this.props.refreshFlag}
                      rowColBaseGrid={this.props.rowColBaseGrid}
                      isSingleBase={this.props.isSingleBase}
                      useQuestions={this.props.useQuestions}
                      partsToShow={this.props.partsToShow}
                    />
                  </div>
                )}
              {!this.props.noExpressionBox && (
                <div className="column row expanded">
                  <ExpressionCreatorV2
                    ref={this.expressionCreator}
                    refreshFlag={this.props.refreshFlag}
                    selectedModule={this.props.moduleName}
                    moduleStudy={this.props.moduleStudy}
                    getSampleWeighted={
                      this.props.moduleAction.getSampleWeighted
                    }
                    gridData={this.props.gridData}
                    trackerFn={this.props.trackerFn}
                    moduleWeigthType={this.props.weightTypes}
                    breadcrumbFlag={this.props.breadcrumbFlag}
                    noCRB={!this.props.rowColBaseGrid} // true in case CRB grid is not being used
                    noDefinitionsFlag={
                      !(
                        this.props.dictionaryTabsList &&
                        this.props.dictionaryTabsList.includes('definition')
                      )
                    } // true in case definition tag is not being used
                  />
                </div>
              )}
            </div>
            <div
              className="small-12 medium-4 large-4 columns"
              style={{ borderLeft: '1px solid #91a2b9' }}
            >
              {this.props.sampleTabsEnabled && (
                <SampleTabsV2
                  handleAnswersPreview={this.handleAnswersPreview}
                  moveAppendToCodingBox={this.moveAppendToCodingBox}
                  trackerFn={this.props.trackerFn}
                  tabTracker={this.tabTracker}
                  BasesDataGridData={this.props.BasesDataGridData}
                  ColumnsDataGridData={this.props.ColumnsDataGridData}
                  RowsDataGridData={this.props.RowsDataGridData}
                  ScratchDataGridData={this.props.ScratchDataGridData}
                  moduleStudy={this.props.moduleStudy}
                  moduleWeigthType={this.props.weightTypes}
                  sampleWeightedKPIs={this.props.sampleWeightedKPIs}
                  recycleElements={this.props.recycleElements}
                  moduleAction={this.props.moduleAction}
                  rightGridList={this.props.rightGridList}
                  isSingleBase={this.props.isSingleBase}
                  breadcrumbFlag={this.props.breadcrumbFlag}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DictionarySearchV2.propTypes = {
  moduleStudy: PropTypes.shape({
    st: PropTypes.string,
  }).isRequired,
  crosstab: PropTypes.shape({}),
  gridData: PropTypes.shape({}).isRequired,
  geographyActions: PropTypes.shape({
    handleSearchGeographyTreeLoad: PropTypes.func,
    handleGeographySearch: PropTypes.func,
    clearGeographySmartSearchData: PropTypes.func,
  }),
  trackerFn: PropTypes.func.isRequired,
  dataScreen: PropTypes.string,
  activeAccountId: PropTypes.number,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  weightTypes: PropTypes.shape({}).isRequired,
  runReport: PropTypes.func,
  studies: PropTypes.arrayOf(PropTypes.shape({})),
  handleStudyChange: PropTypes.func,
  BasesDataGridData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  ColumnsDataGridData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  RowsDataGridData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  ScratchDataGridData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hideWeightType: PropTypes.bool,
  sampleWeightedKPIs: PropTypes.shape({}),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  handleChangeWeightType: PropTypes.func,
  featureID: PropTypes.number.isRequired,
  // dataOnScreen: PropTypes.boolean,
  alertMsg: PropTypes.string,
  menuName: PropTypes.string,
  moduleAction: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    setLabelTypeAC: PropTypes.func,
    setDictionaryUseQuestions: PropTypes.func,
  }).isRequired,
  rightGridList: PropTypes.arrayOf(PropTypes.string),
  handleRun: PropTypes.func,
  moduleName: PropTypes.string.isRequired,
  sampleTabsEnabled: PropTypes.bool,
  backBtnLabel: PropTypes.string,
  backBtnAction: PropTypes.func,
  mainMenuName: PropTypes.string.isRequired,
  dictionaryTabsList: PropTypes.arrayOf(PropTypes.string),
  noExpressionBox: PropTypes.bool,
  functionProbabilitiesFlag: PropTypes.bool,
  breadcrumbFlag: PropTypes.bool,
  refreshFlag: PropTypes.bool,
  rowColBaseGrid: PropTypes.bool,
  isSingleBase: PropTypes.bool,
  windowHeight: PropTypes.shape({}),
  isRunEnabled: PropTypes.bool,
  useQuestions: PropTypes.bool,
  partsToShow: PropTypes.shape({}),
};

DictionarySearchV2.defaultProps = {
  sampleTabsEnabled: true,
  recycleElements: [],
  rowColBaseGrid: false,
  isSingleBase: false,
  breadcrumbFlag: false,
  windowHeight: { height: 'calc(100vh - 57px)' },
  isRunEnabled: false,
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    studies: state.study.studies,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    geographyActions: bindActionCreators(geographyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DictionarySearchV2);
